/* eslint-disable react-hooks/exhaustive-deps */
/* eslint-disable no-unused-vars */
import {
  Alert,
  FormControl,
  IconButton,
  InputLabel,
  MenuItem,
  OutlinedInput,
  Paper,
  Select,
  Switch,
  Tooltip,
  Typography,
} from "@mui/material";
import Grid from "@mui/material/Grid";
import { useEffect, useState } from "react";
import { getCountries} from "../../services/list.service";
import {
  isEmptyObject,
  isEmptyString,
  isNullUndefined,
  isValidDate,
  isValidPhoneNumber,
  tryParseFloat,
  tryParseInt,
} from "../../util/util";
import {
  fetchOrganization,
  fetchOrganizationSecure,
  saveOrganization,
} from "../../services/organisation.service";
import Permit from "../../util/permit";
import "dayjs/locale/en-gb";
import { ResponsiveRow } from "../../constants/layout.constants";
import ModalContainerModule from "../modules/modalContainer";
import {
  issueErrorMessage,
  issueResponseMessage,
  issueWarnMessage,
} from "../../actions/message";
import { Add, Cached } from "@mui/icons-material";
import ContractContactModal from "./contractContactModal";
import AddNewUser from "./addNewUser";
import { useSelector } from "react-redux";
import { DatePicker, LocalizationProvider } from "@mui/x-date-pickers";
import { AdapterDayjs } from "@mui/x-date-pickers/AdapterDayjs";
import dayjs from "dayjs";

/**
 *Required props are:
 - openModal: True or false to show or hide modal respectively.
 - closeModal: Function to close the modal ie set showTerminateModal to false.
 - selectedOrg: Organisation data to populate form.
 - searchedName: To preload organisation name when adding a new user
 - customer: Boolean. To render additional credit limit component.
 - task: Edit
 - saveOrg: To save an organisation customer
 */

export default function AddNewOrganization(props) {
const initialContactState = {
    id: "",
    firstName: "",
    middleName: "",
    lastName: "",
    mobilePhone: "",
    officePhone: "",
    email: "",
    credentialId: "",
    idNumber: "",
    idTypeCd: "",
  }
  const [companyName, setCompanyName] = useState("");
  const [description, setDescription] = useState("");
  const [address1, setAddress1] = useState("");
  const [address2, setAddress2] = useState("");
  const [city, setCity] = useState("");
  const [countryCd, setCountry] = useState("");
  const [taxId, setTaxId] = useState("");
  const [absoluteCreditLimit, setAbsoluteCreditLimit] = useState(0);
  const [idNoSearch, setIdNo] = useState("");
  const [idTypeSearch, setIdType] = useState("");
  const [countryOptions, setCountryOptions] = useState([]);
  const [selectedOrg, setSelectedOrg] = useState(props.selectedOrg);
  const [approveCapitalFunds, setApproveCapitalFunds] = useState(false);
  const [viewOnlyAccess, setViewOnlyAccess] = useState(false);
  const [approveBudgets, setApproveBudgets] = useState(false);
  const [contactNote, setContactNote] = useState(props?.selectedOrg?.contact?.contactNote || "");
  const [contactModal, setContactModal] = useState(false);
  const [showAddNewContact, setShowAddNewContact] = useState(false);
  const [showAddPerson, setShowAddPerson] = useState(false);

  const isLoggedIn = useSelector((state) => state.auth.isLoggedIn);
  const isProxy = useSelector((state) => state.auth.user.isProxy);
  const disabledInput = (!props?.allowEditOrg || (selectedOrg?.systemOrganization && isProxy)) &&
    (props.task === "Edit" || (props.task === "Add" && selectedOrg?.id));

  useEffect(() => {
    if (isNullUndefined(props.selectedOrg)) {
      let data = {
        id: null,
        name: props.searchedName,
        description: "",
        taxId: "",
        address: {
          id: "",
          address1: "",
          address2: "",
          countryCd: "",
          city: "",
        },
        contact: initialContactState,
        absoluteCreditLimit: "",
        billingPeriod: "",
        billingDay: "",
        type: "Company",
      };
      setSelectedOrg(data);
      setCompanyName(props.searchedName);
    } else {
      setSelectedOrg(props.selectedOrg);
      setCompanyName(props.searchedName);
    }
  }, [props.searchedName]);

  useEffect(() => {
    if (!isNullUndefined(props.task) && props.task === "Edit") {
      // setSelectedOrg(selectedOrg ?? props.selectedOrg);
      if (selectedOrg && selectedOrg.permissions) {
        if (selectedOrg.permissions.indexOf("view only access") >= 0) {
          setViewOnlyAccess(true);
        }
        if (selectedOrg.permissions.indexOf("capital fund") >= 0) {
          setApproveCapitalFunds(true);
        }
        if (selectedOrg.permissions.indexOf("budget") >= 0) {
          setApproveBudgets(true);
        }
      }
    }
  }, [selectedOrg]);

  useEffect(() => {
    getCountries().then((countryOptions) => setCountryOptions(countryOptions));

    if (
      props.contractType === "vendor" &&
      props.selectedOrg?.id &&
      props.selectedOrg?.address
    ) {
      setSelectedOrg(props.selectedOrg);
      return;
    }

    if (!isNullUndefined(props?.selectedOrg?.id)) {
      const orgIdString = props?.selectedOrg?.id;
      const orgId =
        props?.selectedOrg?.tenantId && props?.selectedOrg?.tenantId !== ""
          ? props?.selectedOrg?.tenantId
          : orgIdString.includes("_") 
          ? orgIdString.split("_")[0]
          : orgIdString;

      if (isLoggedIn && isProxy) {
        fetchOrganizationSecure(orgId).then((organization) => {
          setSelectedOrg(organization);
        });
      } else {
        fetchOrganization(orgId).then((organization) => {
          setSelectedOrg(organization);
        });
      }
    }
  }, []);

  function handleSwitchToggleChanged(event, permission) {
    let obj = selectedOrg;
    if (permission === "capital fund") {
      if (event.target.checked) {
        obj.permissions.push(permission);
        setApproveCapitalFunds(true);
      } else {
        obj.permissions.splice(obj.permissions.indexOf("capital fund"));
        setApproveCapitalFunds(false);
      }
    } else if (permission === "budget") {
      if (event.target.checked) {
        obj.permissions.push(permission);
        setApproveBudgets(true);
      } else {
        obj.permissions.splice(obj.permissions.indexOf("budget"));
        setApproveBudgets(false);
      }
    } else if (permission === "view only access") {
      if (event.target.checked) {
        obj.permissions.push(permission);
        setViewOnlyAccess(true);
      } else {
        obj.permissions.splice(obj.permissions.indexOf("view only access"));
        setViewOnlyAccess(false);
      }
    }
    setSelectedOrg(obj);
  }

  function handleCountryChange(event) {
    let value = event.target.value;
    setCountry(value);
    let tmp = { ...selectedOrg, address: { ...selectedOrg.address } };
    tmp.address.countryCd = value;
    setSelectedOrg(tmp);
  }

  function validateForm() {
    let sendData = selectedOrg;
    if (isNullUndefined(sendData)) {
      issueErrorMessage(
        "Could not find data, please refresh the page and try again.",
      );
      return false;
    }
    if (isEmptyString(sendData.name)) {
      issueWarnMessage("Company name is required.");
      return false;
    }
    if (isEmptyString(sendData.address.address1)) {
      issueWarnMessage("Address is required.");
      return false;
    }
    if (isEmptyString(sendData.address.city)) {
      issueWarnMessage("City is required.");
      return false;
    }
    if (isEmptyString(sendData.address.countryCd)) {
      issueWarnMessage("Please select a country");
      return false;
    }
    if(isProxy) {
      if(isEmptyObject(sendData.contact)) {
        issueWarnMessage("A company contact is required");
        return false;
      }
      if (
        isEmptyString(sendData.contact.firstName) ||
        isEmptyString(sendData.contact.lastName)
      ) {
        issueWarnMessage("Contact's First name and Last name are required.");
        return false;
      }
      if (
        isNullUndefined(sendData.contact.mobilePhone) ||
        isEmptyString(sendData.contact.mobilePhone)
      ) {
        issueWarnMessage("Contact's Mobile Phone number is required.");
        return false;
      }
      const mobilePhone = sendData.contact.mobilePhone;
      const officePhone = sendData.contact.officePhone;
      const { isValid, errors } = isValidPhoneNumber(mobilePhone);
      if (!isValid) {
        issueWarnMessage(`Contact's Mobile phone number is invalid. ${errors.join(". ")}`);
        return false;
      }

      if (officePhone) {
        if (officePhone === mobilePhone) {
          issueWarnMessage(
            `Contact's Office phone number cannot be same as mobile phone number. Leave blank if you don't have a separate phone number.`,
          );
          return false;
        }

        const { isValid, errors } = isValidPhoneNumber(officePhone);
        if (!isValid) {
          issueWarnMessage(
            `Contact's Office phone number is invalid. ${errors.join(". ")}`,
          );
          return false;
        }
      }
      if (
        isNullUndefined(sendData.contact.idNumber) ||
        isEmptyString(sendData.contact.idNumber) ||
        isNullUndefined(sendData.contact.idTypeCd) ||
        isEmptyString(sendData.contact.idTypeCd)
      ) {
        issueWarnMessage("Must provide Contact's ID number and ID type.");
        return false;
      }
    }
    if (props.customer) {
      let creditLimit = tryParseFloat(sendData.absoluteCreditLimit, -1);
      if (creditLimit < 0) {
        issueWarnMessage("Must provide a valid credit Limit.");
        return false;
      }
      sendData.absoluteCreditLimit = creditLimit;

      if (sendData.billingPeriod === "MNTH") {
        if (
          isNullUndefined(sendData.billingDay) ||
          isEmptyString(sendData.billingDay)
        ) {
          issueWarnMessage("Must provide a billing day.")
          return false
        }
        let billingDay = tryParseInt(sendData.billingDay, -1)
        if (billingDay < 0) {
          issueWarnMessage("Must provide a valid billing day.")
          return false
        }
        sendData.billingDay = billingDay
      }

      if (sendData.billingPeriod === "QT" || sendData.billingPeriod === "ANU") {
        if (
          isNullUndefined(sendData.billingDate) ||
          isEmptyString(sendData.billingDate)
        ) {
          issueWarnMessage("Must provide a billing date.")
          return false
        }
        let date = new Date(sendData.billingDate)
        if (!isValidDate(date)) {
          issueWarnMessage("Must provide a valid date.")
          return false
        }
        sendData.billingDate = date
      }
    }

    // Preserve the organization ID for updates
    if (
      selectedOrg?.id &&
      !isNullUndefined(selectedOrg.id) &&
      !isEmptyString(selectedOrg.id)
    ) {
      sendData.id = selectedOrg.id;
    } else if (
      props?.selectedOrg?.tenantId &&
      !isEmptyString(props?.selectedOrg?.tenantId)
    ) {
      sendData.id = props?.selectedOrg?.tenantId;
    }

    // Preserve the billingId for updates (required by backend to determine update vs create)
    if (
      selectedOrg?.billingId &&
      !isNullUndefined(selectedOrg.billingId) &&
      !isEmptyString(selectedOrg.billingId)
    ) {
      sendData.billingId = selectedOrg.billingId;
    } else if (
      props?.selectedOrg?.billingId &&
      !isNullUndefined(props.selectedOrg.billingId) &&
      !isEmptyString(props.selectedOrg.billingId)
    ) {
      sendData.billingId = props.selectedOrg.billingId;
    }

    setSelectedOrg(sendData);
    return true;
  }

  function handleSaveOrgClicked() {
    if (validateForm()) {
      if (!isNullUndefined(props.handleSave) && props.handleSave === true) {
        const saving = props.saveOrg(selectedOrg);
        // Parents that save on the server hand back a promise: wait for it, and
        // keep this form open when the save is rejected (e.g. the contact's
        // email or phone is not available). Parents that only make a selection
        // return nothing, so there is nothing to wait for.
        if (!isNullUndefined(saving) && typeof saving.then === "function") {
          saving.then((response) => {
            if (isNullUndefined(response) || response.type === "error") return;
            closeModal();
          });
        } else {
          closeModal();
        }
      } else {
        saveOrganization(selectedOrg).then((response) => {
          if (response) {
            issueResponseMessage(response);
            if (response.type !== "error") {
              closeModal();
            }
          }
        });
      }
    }
  }

  function handleOk() {
    if(props?.contractType === "vendor" && !isNullUndefined(props?.handleProceed)) {
      props.handleProceed(selectedOrg)
      setSelectedOrg(null);
    } else {
      handleSaveOrgClicked();
    }
  }

  function closeModal() {
    props.closeModal();
    setSelectedOrg(null);
  }

  const handleContactClose = () => {
    setContactModal(false);
  };

  const updateContactFromResult = (result, org) => {
    let tmp = initialContactState;
    Object.keys(result).forEach((key) => {
      if (key in tmp) {
        tmp[key] = result[key] ?? "";
      }
    });
    tmp.name = tmp.firstName + " " + tmp.lastName;
    org.contact = tmp;
    return org;
  };

  const handlePersonSelect = (result) => {
    setSelectedOrg(updateContactFromResult(result, selectedOrg));
    setContactModal(false);
  };

  const handleConfirmPerson = (result) => {
    setSelectedOrg(updateContactFromResult(result, selectedOrg));
    setShowAddPerson(true);
    setContactModal(false);
  };

  const showAddNewContactForm = (idNoSearch, idTypeSearch) => {
    setIdType(idTypeSearch);
    setIdNo(idNoSearch);
    let tmp = { ...initialContactState };
    tmp.idTypeCd = idTypeSearch;
    tmp.idNumber = idNoSearch;
    let tmp2 = selectedOrg;
    tmp2.contact = tmp;
    setSelectedOrg(tmp2);
    setShowAddPerson(true);
  };

  const handleAddUserClose = () => {
    const updatedContact = {...initialContactState};
        setSelectedOrg((prev) => ({
          ...prev,
          contact: updatedContact
        }));
        setShowAddPerson(false);
  };

  const handleClose = () => {
    props.closeModal();
    setSelectedOrg(null);
  };

  let modalTitle =
    !isNullUndefined(props.task) && props.task === "Edit"
      ? "Edit Organization"
      : "Add Organization";
  let acceptButtonText =
    !isNullUndefined(props?.contractType) && props.contractType === "vendor" 
      ? "Proceed" :!isNullUndefined(props.task) && props.task === "Edit"
      ? "Update Organization"
      : "Create Organization";
  let headingText = "Organization's Details";
  if (props.customer) {
    modalTitle =
      !isNullUndefined(props.task) && props.task === "Edit"
        ? "Edit Customer"
        : "Add Customer";
    acceptButtonText =
      !isNullUndefined(props.task) && props.task === "Edit"
        ? "Update"
        : "Create Customer";
    headingText = "Customer's Details";
  }

  return (
      <ModalContainerModule
        size="sm"
        accept={handleOk}
        openModal={props.openModal}
        cancel={handleClose}
        modalTitle={modalTitle}
        acceptButtonText={acceptButtonText}
      >
        <Typography
          sx={{ marginBottom: "20px" }}
          id="addUser"
          variant="h5"
          component="h4"
        >
          {headingText}
        </Typography>

        <ResponsiveRow sx={{ height: "auto" }} container>
          <FormControl
            item
            sx={{
              width: { xs: "100%", lg: "33.3%" },
              marginBottom: "10px",
            }}
            disabled={disabledInput}
          >
            <InputLabel required>Company Name</InputLabel>
            <OutlinedInput
              label={"Company Name"}
              sx={{ width: { xs: "100%", md: "90%" } }}
              id={"companyName"}
              onChange={(event) => {
                const value = event.target.value;
                setCompanyName(value);
                let tmp = { ...selectedOrg };
                tmp.name = value;
                setSelectedOrg(tmp);
              }}
              value={selectedOrg?.name ?? companyName}
            />
          </FormControl>

          <FormControl
            item
            sx={{
              width: { xs: "100%", lg: "33.3%" },
              marginBottom: "10px",
            }}
            disabled={disabledInput}
          >
            <InputLabel required>Address 1</InputLabel>
            <OutlinedInput
              label={"Address 1"}
              sx={{ width: { xs: "100%", md: "90%" } }}
              id={"address1"}
              onChange={(event) => {
                const value = event.target.value;
                setAddress1(value);
                let tmp = { ...selectedOrg, address: { ...selectedOrg.address } };
                tmp.address.address1 = value;
                setSelectedOrg(tmp);
              }}
              value={selectedOrg?.address?.address1 ?? address1 ?? ""}
            />
          </FormControl>

          <FormControl
            item
            sx={{
              width: { xs: "100%", lg: "33.3%" },
              marginBottom: "10px",
            }}
            disabled={disabledInput}
          >
            <InputLabel>Address 2</InputLabel>
            <OutlinedInput
              label={"Address 2"}
              sx={{ width: { xs: "100%", md: "90%" } }}
              id={"address2"}
              onChange={(event) => {
                const value = event.target.value;
                setAddress2(value);
                let tmp = { ...selectedOrg, address: { ...selectedOrg.address } };
                tmp.address.address2 = value;
                setSelectedOrg(tmp);
              }}
              value={selectedOrg?.address?.address2 ?? address2 ?? ""}
            />
          </FormControl>

          <FormControl
            item
            sx={{
              width: { xs: "100%", lg: "33.3%" },
              marginBottom: "10px",
            }}
            disabled={disabledInput}
          >
            <InputLabel required>Country</InputLabel>
            <Select
              label="Country"
              sx={{ width: { xs: "100%", md: "90%" } }}
              id={"country"}
              value={selectedOrg?.address?.countryCd ?? countryCd ?? ""}
              onChange={(event) => handleCountryChange(event)}
            >
              {countryOptions && countryOptions.length > 0 ? (
                countryOptions.map(function (country, i) {
                  return (
                    <MenuItem key={country.value} value={country.value}>
                      {country.label}
                    </MenuItem>
                  );
                }, this)
              ) : (
                <MenuItem sx={{ width: "100%" }}>No Results Found</MenuItem>
              )}
            </Select>
          </FormControl>

          <FormControl
            item
            sx={{
              width: { xs: "100%", lg: "33.3%" },
              marginBottom: "10px",
            }}
            disabled={disabledInput}
          >
            <InputLabel required>City</InputLabel>
            <OutlinedInput
              label={"City"}
              sx={{ width: { xs: "100%", md: "90%" } }}
              id={"city"}
              onChange={(event) => {
                const value = event.target.value;
                setCity(value);
                let tmp = { ...selectedOrg, address: { ...selectedOrg.address } };
                tmp.address.city = value;
                setSelectedOrg(tmp);
              }}
              value={selectedOrg?.address?.city ?? city ?? ""}
            />
          </FormControl>

          <FormControl
            sx={{
              width: { xs: "100%", lg: "33.3%" },
              marginBottom: "10px",
            }}
            disabled={disabledInput}
          >
            <InputLabel>Description</InputLabel>
            <OutlinedInput
              label={"Description"}
              sx={{ width: { xs: "100%", md: "90%" } }}
              id={"description"}
              onChange={(event) => {
                const value = event.target.value;
                setDescription(value);
                let tmp = { ...selectedOrg };
                tmp.description = value;
                setSelectedOrg(tmp);
              }}
              value={selectedOrg ? selectedOrg?.description : description}
            />
          </FormControl>

          <FormControl
            sx={{
              width: { xs: "100%", lg: "33.3%" },
              marginBottom: "10px",
            }}
            disabled={disabledInput}
          >
            <InputLabel>Tax ID</InputLabel>
            <OutlinedInput
              label={"Tax Id"}
              sx={{ width: { xs: "100%", md: "90%" } }}
              id={"taxId"}
              onChange={(event) => {
                const value = event.target.value;
                setTaxId(value);
                let tmp = { ...selectedOrg };
                tmp.taxId = value;
                setSelectedOrg(tmp);
              }}
              value={selectedOrg?.taxId ?? taxId ?? ""}
            />
          </FormControl>
          {isProxy && (
            <FormControl
              sx={{
                width: { xs: "100%", lg: "33%" },
                height: "60px",
                marginBottom: "10px",
                display: "flex",
                flexDirection: "row",
                flexWrap: "nowrap",
                alignItems: "center",
              }}
              key={selectedOrg?.contact?.name}
            >
              <InputLabel htmlFor="contactPerson">Contact Person</InputLabel>
              <OutlinedInput
                label="Contact Person"
                id="contactPerson"
                sx={{ width: "90%" }}
                autoFocus={selectedOrg?.systemOrganization}
                value={selectedOrg?.contact?.name ?? ""}
                readOnly
                endAdornment={
                  <IconButton
                    onClick={() => setContactModal(true)}
                    sx={{
                      width: "40px",
                      height: "40px",
                      margin: "0 10px",
                      padding: "10px",
                      backgroundColor: "#037171",
                    }}
                  >
                    {(() => {
                      const hasContact =
                        (!isNullUndefined(selectedOrg?.contact?.id) &&
                          !isEmptyString(selectedOrg?.contact?.id)) ||
                        (!isNullUndefined(selectedOrg?.contact?.firstName) &&
                          !isEmptyString(selectedOrg?.contact?.firstName));

                      return !hasContact ? (
                        <Tooltip title="Add contact person">
                          <Add sx={{ color: "white" }} />
                        </Tooltip>
                      ) : (
                        <Tooltip title="Switch contact person">
                          <Cached sx={{ color: "white" }} />
                        </Tooltip>
                      );
                    })()}
                  </IconButton>
                }
              />
            </FormControl>
          )}
          
          {isProxy && selectedOrg?.systemOrganization && selectedOrg?.contact.name && (
            <FormControl
              item
              sx={{
                width: { xs: "100%", lg: "33.3%" },
                marginBottom: "10px",
              }}
            >
              <InputLabel>Contact Note</InputLabel>
              <OutlinedInput
                label={"Contact Note"}
                sx={{ width: { xs: "100%", md: "90%" } }}
                id={"contactNote"}
                multiline
                rows={4}
                onChange={(event) => {
                  const value = event.target.value;
                  setContactNote(value);
                  let tmp = { ...selectedOrg };
                  tmp.contactNote = value;
                  setSelectedOrg(tmp);
                }}
                value={contactNote}
              />
            </FormControl>
          )}
        </ResponsiveRow>

        <br />
        <ResponsiveRow
          sx={{
            width: "100%",
            height: "auto",
          }}
        >
          {selectedOrg &&
            !isNullUndefined(selectedOrg.roleCode) &&
            selectedOrg.roleCode === "OWN" && (
              <Paper
                variant=""
                sx={{
                  margin: "auto",
                  padding: "10px",
                  textAlign: "left",
                }}
              >
                <Permit roles="BLDIR,BLDMG,REC,CS" services="HOA">
                  <Typography id="permissions" variant="h6" component="h6">
                    Activate Permissions at this Property.
                  </Typography>
                </Permit>
                <Alert severity="info">
                  Activating permission will make an owner a committee member
                  for respective granted permission. That is
                  <span
                    style={{
                      padding: 5,
                      fontWeight: "bold",
                    }}
                  >
                    Capital Fund Committee
                  </span>
                  or
                  <span
                    style={{
                      padding: 5,
                      fontWeight: "bold",
                    }}
                  >
                    Budget Committee
                  </span>
                  or
                  <span
                    style={{
                      padding: 5,
                      fontWeight: "bold",
                    }}
                  >
                    Both.
                  </span>
                </Alert>
                <br />

                <ResponsiveRow sx={{ height: "auto" }} container>
                  <FormControl
                    item
                    sx={{
                      width: { xs: "100%", lg: "33.3%" },
                      marginBottom: "10px",
                    }}
                  >
                    <InputLabel>View Only Access</InputLabel>
                    <Switch
                      checked={viewOnlyAccess}
                      onChange={(event) =>
                        handleSwitchToggleChanged(event, "view only access")
                      }
                      inputProps={{ "aria-label": "controlled" }}
                    />
                  </FormControl>

                  <Grid
                    item
                    sx={{
                      width: { xs: "100%", lg: "33.3%" },
                      marginBottom: "10px",
                    }}
                  >
                    <InputLabel>Is a Capital Fund Committee Member</InputLabel>
                    <Switch
                      checked={approveCapitalFunds}
                      onChange={(event) =>
                        handleSwitchToggleChanged(event, "capital fund")
                      }
                      inputProps={{ "aria-label": "controlled" }}
                    />
                  </Grid>

                  <FormControl
                    item
                    sx={{
                      width: { xs: "100%", lg: "33.3%" },
                      marginBottom: "10px",
                    }}
                  >
                    <InputLabel>Is a Budget Committee Member</InputLabel>
                    <Switch
                      checked={approveBudgets}
                      onChange={(event) =>
                        handleSwitchToggleChanged(event, "budget")
                      }
                      inputProps={{ "aria-label": "controlled" }}
                    />
                  </FormControl>
                </ResponsiveRow>
              </Paper>
            )}

          {props.customer && (
            <Typography
              sx={{ marginBottom: "20px" }}
              id="absoluteCreditLimit"
              variant="h5"
              component="h4"
            >
              Add Customer Info
            </Typography>
          )}
          {props.customer && (
            <ResponsiveRow sx={{ width: "100%", height: "auto" }} container>
              <FormControl
                item
                sx={{
                  width: { xs: "100%", lg: "33.3%" },
                  marginBottom: "10px",
                }}
              >
                <InputLabel required>Credit Limit</InputLabel>
                <OutlinedInput
                  id="absoluteCreditLimit"
                  label="Credit Limit"
                  sx={{
                    width: { xs: "100%", md: "90%" },
                  }}
                  onChange={(event) => {
                    let value = event.target.value;
                    setAbsoluteCreditLimit(value);
                    let obj = { ...selectedOrg };
                    obj.absoluteCreditLimit = value;
                    setSelectedOrg(obj);
                  }}
                  value={
                    selectedOrg?.absoluteCreditLimit ?? absoluteCreditLimit ?? 0
                  }
                />
              </FormControl>
              <FormControl
                item
                sx={{
                  width: { xs: "100%", lg: "33.3%" },
                  marginBottom: "20px",
                }}
              >
                <InputLabel required>Billing Frequency</InputLabel>
                <Select
                  label="Billing Frequency"
                  sx={{ width: { xs: "100%", md: "90%" } }}
                  id={"billingPeriod"}
                  value={selectedOrg?.billingPeriod}
                  onChange={(event) => {
                    let billingPeriod = event.target.value;
                    let obj = { ...selectedOrg };
                    obj.billingPeriod = billingPeriod;
                    setSelectedOrg(obj);
                  }}
                >
                  {props.billingPeriods && props.billingPeriods.length > 0 ? (
                    props.billingPeriods.map(function (billingPeriod, i) {
                      return (
                        <MenuItem key={i} value={billingPeriod.value}>
                          {billingPeriod.label}
                        </MenuItem>
                      );
                    }, this)
                  ) : (
                    <MenuItem sx={{ width: "100%" }}>No Results Found</MenuItem>
                  )}
                </Select>
              </FormControl>

            {selectedOrg?.billingPeriod === "MNTH" && (
              <FormControl
                item
                sx={{
                  width: { xs: "100%", lg: "33.3%" },
                  marginBottom: "10px",
                }}
              >
                <InputLabel required>Billing Due Day</InputLabel>
                <Select
                  label={"Billing Due Day"}
                  sx={{ width: { xs: "100%", lg: "90%" } }}
                  id={"billingDay"}
                  value={selectedOrg?.billingDay}
                  onChange={(e) => {
                    let billingDay = e.target.value;
                    let obj = { ...selectedOrg };
                    obj.billingDay = billingDay;
                    setSelectedOrg(obj);
                  }}
                  defaultValue={[""]}
                >
                  {props?.meterBillingDays && props?.meterBillingDays.length > 0 ? (
                    props?.meterBillingDays.map(function (weekDay, i) {
                      return (
                        <MenuItem key={i} value={weekDay.value}>
                          {weekDay.label}
                        </MenuItem>
                      );
                    }, this)
                  ) : (
                    <MenuItem sx={{ width: "100%" }}>No Results Found</MenuItem>
                  )}
                </Select>
              </FormControl>
            )}
            {selectedOrg?.billingPeriod &&
              (selectedOrg?.billingPeriod === "ANU" || selectedOrg?.billingPeriod === "QT") && (
                <FormControl
                  item
                  sx={{
                    width: { xs: "100%", lg: "33.3%" },
                    marginBottom: "10px",
                  }}
                >
                  <LocalizationProvider
                    dateAdapter={AdapterDayjs}
                    adapterLocale="en-gb"
                  >
                    <DatePicker
                      label={"Next Rent Due Date"}
                      sx={{ width: { xs: "100%", lg: "90%" } }}
                      id={"nextRentDate"}
                      value={dayjs(selectedOrg?.billingDate)}
                      onChange={(event) => {
                        let value = event.target.value;
                        let date = new Date(value);
                        let obj = { ...selectedOrg };
                        obj.billingDate = date;
                        setSelectedOrg(obj);
                      }}
                      disablePast
                    />
                  </LocalizationProvider>
                </FormControl>
              )}
            </ResponsiveRow>
          )}
        </ResponsiveRow>

        <ContractContactModal
          contractType={"Organization"}
          contactModal={contactModal}
          handleContactClose={handleContactClose}
          handlePersonOrgSelect={handleConfirmPerson}
          showAddNewContactForm={showAddNewContactForm}
          setShowAddNewContact={setShowAddNewContact}
        />

        {showAddPerson && (
          <AddNewUser
            openModal={showAddPerson}
            closeModal={handleAddUserClose}
            searchedIdType={idTypeSearch}
            searchedIdNo={idNoSearch}
            saveUser={handlePersonSelect}
            selectedPerson={selectedOrg.contact}
            allowEditUser={(props?.allowEditOrg || props?.allowEditContact)}
            task={(selectedOrg.contact.id ? "Edit" : "Create")}
            organizationContact={true}
            customer={false}
          />
        )}
      </ModalContainerModule>
   
  );
}
